import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRefresh,
  faArrowCircleRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  AssetSubStatus,
  DefaultDateFormat,
  IconWithTooltip,
  AssetQuotationType,
} from "../../../helper/fixcode";
import { Template } from "devextreme-react";
import { assetService } from "../../../apis/apiServices/Asset";
import { Icon } from "@iconify/react/dist/iconify.js";
import Modal from "react-modal";
import { askConfirmation, showResponseMessage } from "../../../helper/message";
import { Loader } from "../../Shared/PageLoader";
import moment from "moment";

export default function RequestForAssetPurchaseComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [state, setState] = useState({
    isSaveVendorModalOpen: false,
    isCompleteLoading: false,
    loadingMessage: "",
  });
  const [assetQuotationRequest, setAssetQuotationRequestList] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Asset Purchase";
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getQuotationRequestLst();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getQuotationRequestLst = async () => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
       setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));

      let body = {
        requestQuotationId: 0,
        statusId: 0,
        userId: user?.userId,
        quotationTypeId: AssetQuotationType.RequestForAssetPurchase,
      };
      const response = await assetService.assetQuotationList(body);
      const data = response?.data.filter(
        (e) => e.statusId !== AssetSubStatus.RequestForAssetPurchaseApproved
      );
      setAssetQuotationRequestList(data);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const handleOnCloseAssetVendorModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isSaveVendorModalOpen: false,
      }));

      //setSelectedRowKeys([]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={assetQuotationRequest}
              ref={refDataGrid}
              keyExpr="requestQuotationId"
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              columnAutoWidth={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  // {
                  //   location: "before",
                  //   template: "toolbarAddTemplate",
                  // },
                  {
                    location: "before",
                    template: "toolbarRefreshTemplate",
                  }
                  //   {
                  //     location: "after",
                  //     widget: "dxButton",
                  //     options: {
                  //       icon: "refresh",
                  //       onClick: async () => {
                  //         await getQuotationRequestLst();
                  //       },
                  //     },
                  //   }
                );
              }}
            >
              <Column
                dataField="requestQuotationId"
                width={140}
                caption={""}
                allowExporting={false}
                allowSearch={false}
                allowFiltering={false}
                allowSorting={false}
                cellRender={(data) => {
                  const rowData = data?.data;
                  const idPrefix = `icon-${rowData?.requestQuotationId}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        {props?.featurePermission?.canView && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View"
                                tooltip="View"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  navigate("/asset-purchase-preview", {
                                    state: {
                                      requestQuotationId:
                                        data?.data?.requestQuotationId,
                                      quotationIndentNo:
                                        data?.data?.quotationIndentNo,
                                      quotationTypeId:
                                        data?.data?.quotationTypeId,
                                      sourceUrl: "RequestAssetPurchase",
                                      isReport: false,
                                    },
                                  })
                                }
                              />
                            </span>
                          </>
                        )}

                        {(data.data.statusId ===
                          AssetSubStatus.RequestForAssetPurchasePending ||
                          data.data.statusId ===
                            AssetSubStatus.RequestForAssetPurchaseInDraftMode) &&
                          rowData?.actionAllowed && (
                            <>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-delete`}
                                  className="iconify-size mr-1"
                                  title="Delete"
                                  tooltip="Delete"
                                  icon="fluent:delete-32-regular"
                                  style={{ cursor: "pointer" }}
                                  onClick={async (e) => {
                                    e.preventDefault();
                                    try {
                                      let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to delete asset purchase ${data?.data?.quotationIndentNo}?</span>`;
                                      let isConfirmed = await askConfirmation(
                                        confirmationQuestion,
                                        "Yes",
                                        "No"
                                      );
                                      if (!isConfirmed) return;
                                      const response =
                                        await assetService.deletePurchaseHireMovementRequest(
                                          data?.data?.requestQuotationId,
                                          data?.data?.assetRequestId,
                                          2,
                                          user?.userId,
                                          props?.featurePermission?.featureId
                                        );
                                      isConfirmed = await showResponseMessage(
                                        response
                                      );
                                      if (response?.isSuccess) {
                                        await getQuotationRequestLst();
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                />
                              </span>
                            </>
                          )}
                        {(rowData.statusId ===
                          AssetSubStatus.RequestForAssetPurchasePending ||
                          rowData.statusId ===
                            AssetSubStatus.RequestForAssetPurchaseInDraftMode ||
                          rowData.statusId ===
                            AssetSubStatus.RequestForAssetPurchaseBacktoDraft ||
                          rowData.statusId ===
                            AssetSubStatus.RequestForAssetPurchaseReCall) &&
                          //rowData.departmentId === user?.userDepartmentId &&
                          data.data.actionAllowed && (
                            //rowData.fromId === user.userId &&
                            <button
                              style={{ cursor: "pointer" }}
                              type="button"
                              title="Move"
                              className="btn btn-primary btn-sm-1"
                              onClick={() =>
                                navigate("/addAssetQuotation", {
                                  state: {
                                    requestQuotationId:
                                      data?.data?.requestQuotationId,
                                    quotationTypeId:
                                      data?.data?.quotationTypeId,
                                    quotationIndentNo:
                                      data?.data?.quotationIndentNo,
                                    sourceUrl: "RequestAssetPurchase",
                                  },
                                })
                              }
                            >
                              <Icon
                                className="iconify-size mr-1"
                                icon="ooui:table-move-column-before-rtl"
                                width="14"
                                height="14"
                              />
                              &nbsp;Add Vendor
                            </button>
                          )}
                      </div>
                    </>
                  );
                }}
              ></Column>
              <Column
                dataField="quotationIndentNo"
                caption="Quotation No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetStatusName"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#28A745";
                  if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetQuotationInDraftMode
                  )
                    color = "#494545ff";
                  else if (
                    e.data?.statusId === AssetSubStatus.AssetQuotationApproved
                  )
                    color = "#4CAF50";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetQuotationSendforApproval
                  )
                    color = "#FF9800";



                  //let color = "#28A745";

                  // if (e.data?.statusId === AssetSubStatus.AssetQuotationInDraftMode)
                  //   color = "#494545ff";
                  // else if (
                  //   e.data?.statusId === AssetSubStatus.AssetQuotationApproved
                  // )
                  //   color = "#4CAF50";
                  // else if (
                  //   e.data?.statusId === AssetSubStatus.AssetQuotationSendforApproval
                  // )
                  //   color = "#FF9800";
                  // else if (
                  //   e.data?.statusId === AssetSubStatus.AssetRequestRecall
                  // )
                  //   color = "#ee0a0aff";
                  // else if (
                  //   e.data?.statusId === AssetSubStatus.AssetRequestBackToDraft
                  // )
                  //   color = "#ee0a0aff";

                  var lastUpdatedDate = "";
                  if (!e?.data?.updatedOn) {
                    lastUpdatedDate = moment(e?.data?.createdOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                  }
                  else {
                    const parsedDate = new Date(e?.data?.updatedOn);
                    if (isNaN(parsedDate.getTime())) {
                      lastUpdatedDate = moment(e?.data?.updatedOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                    const minDate = new Date("0001-01-01T00:00:00");
                    if (parsedDate.getTime() === minDate.getTime()) {
                      lastUpdatedDate = moment(e?.data?.createdOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                    else {
                      lastUpdatedDate = moment(e?.data?.updatedOn).format(DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat).toString();
                    }
                  }
                  return (
                    <div>
                      <span style={{ color }}>{e.data?.assetStatusName}</span>
                      {/* <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {e.data?.currentUserId > 0
                          ? e.data?.currentUserName
                          : e.data?.toName}
                      </div> */}
                      <br />
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {lastUpdatedDate}
                      </div>
                    </div>                    
                  );
                }}
              />
              <Column
                dataField="requestedDate"
                caption="Quotation Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format="dd-MMM-yyyy"
              />
              <Column
                dataField="assetRequestSubNo"
                caption="Asset Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              {/* <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
              /> */}

              {/* <Column
                dataField="fromProjectName"
                caption="From Project"
                allowSearch={true}
                allowFiltering={false}
              /> */}
              <Column
                dataField="toProjectName"
                caption="Project"
                allowSearch={true}
                allowSorting={true}
                //alignment={"center"}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.toProjectName) {
                    return (
                      <>
                        <span>{data?.data?.toProjectName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toProjectName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              {/* <Column
                                dataField="fromProjectName"
                                caption="From Project"
                                allowSearch={true}
                                allowSorting={true}
                                //alignment={"center"}
                                allowFiltering={false}
                                cellRender={(data) => {
                                    if (data?.data?.fromProjectName) {
                                        return (
                                            <>
                                                <span>{data?.data?.fromProjectName ?? ""}</span>
                                                <br />
                                                <div style={{ color: '#b1b1b1', fontSize: '11px' }}>
                                                    {data?.data?.toProjectName ?? ""}
                                                </div>
                                            </>
                                        );
                                    } else {
                                        return "";
                                    }
                                }}
                            /> */}
              <Column
                dataField="assetDescriptions"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowSorting={true}
                //alignment={"center"}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.fromName) {
                    return (
                      <>
                        <span>{data?.data?.fromName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.fromDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowSorting={true}
                //alignment={"center"}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.toName) {
                    return (
                      <>
                        <span>{data?.data?.toName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartment ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Template
                name="toolbarAddTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Add Quotation Request"
                        className="btn btn-primary btn-sm mr-1"
                        onClick={(e) => {
                          e.preventDefault();
                          try {
                            navigate("/AddAssetRequest");
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <span title="Add Quotation Request">
                          <i className="fas fa-plus"></i>
                          &nbsp;&nbsp;Add
                        </span>
                      </button>
                    </>
                  );
                }}
              />
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getQuotationRequestLst();
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faRefresh} />
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />
              <Export enabled={true} fileName="Asset Quotation" />
            </DataGrid>
          </div>
        </div>
      </div>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
